<!-- 我的 -->
<template>
 <div class="user">
    <div class="user__member">
     <!--   <div class="user__member-box user__member-box_normal">
        <div class="user__member-info">
          <div class="user__member-info_head--bg">
            <img src="http://img.zhujiaxian.com/2022/08/2ab1dd346283423b93b8ce8639a20614.png" alt="" class="user__member-info_head--img">
          </div>
          <div class="user__member-info_right">
            <div class="user__member-info_top">
              <span class="user__member-info_name">{{userInfo.nickName}}</span>
            </div>
            <div class="user__member-info_bottom">
              <p class="user__member-info_bottom_rank_name">{{userInfo.mobile}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="user__member-level user__member-level_normal">
        <div class="user__member-card">
          <div style="display:flex;flex-direction:column;span-align: center;">
            <div>
              <div style="display:flex;align-items:center;">
                <img src="http://img.zhujiaxian.com/2023/10/fe2c4377b8cd4cd88739eeeff65f5743.png" alt="" style="width: 16px;height:16px;">
                <span style="font-size: 14px;color:#548732;">通用账户</span>
                <img src="http://img.zhujiaxian.com/2023/10/722e8f02a87f41eca9434c807ae91548.png" style="width: 14px;height:14px;" alt="">
              </div>
              <div>
                <div style="font-size:20px;font-weight:700;color: #315816;font-family: DIN;line-height: 23px;margin-top: 10px;">
                  <div style="padding-top: 10px;font-size: 22px;margin-top: 10px;line-height: 23px;display: flex;align-items: center;">{{ globalActivityId === 9 || globalActivityId === 13 ? '<img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px;height: 16px;margin-right: 4px;" alt="积分" />' : '¥' }}{{userInfo.generalBalance.toFixed(2)}}</div>
                </div>
              </div>
            </div>
            <div style="margin-top: 15px;">
              <div style="color:#B1B3B0;display:flex;justify-content:center;align-items: center;">
                <div style="margin-right: 3px;font-size: 12px;line-height: 0px;">有效期至</div>
                <img src="http://img.zhujiaxian.com/2023/10/5f343303b0bc45afaee493dce7a09ac8.png" style="width: 12px;height: 12px;" alt="">
              </div>
              <div style="margin-top: 6px;color:#C8C8C7;font-size: 11px;line-height: 12px;">{{userInfo.generalBalanceExpirationTime}}</div>
            </div>
          </div>
          <div>
            <img src="http://img.zhujiaxian.com/2023/10/f801800f69f6477abf28db81ae522df9.png" style="width:2px;height:49px;margin-top: 6px;" alt="">
          </div>
          <div style="display:flex;flex-direction:column;span-align: center;">
            <div>
              <div style="display:flex;align-items:center;">
                <img src="http://img.zhujiaxian.com/2023/10/fab31d7f6bf04a879942de596c641dd0.png" alt="" style="width: 16px;height:16px;">
                <span style="font-size: 14px;color:#548732;">帮扶账户</span>
                <img src="http://img.zhujiaxian.com/2023/10/722e8f02a87f41eca9434c807ae91548.png" style="width: 14px;height:14px;" alt="">
              </div>
              <div>
                <div style="font-size:20px;font-weight:700;color: #315816;font-family: DIN;line-height: 23px;margin-top: 10px;">
                  <div style="padding-top: 10px;font-size: 22px;margin-top: 10px;line-height: 23px;display: flex;align-items: center;">{{ globalActivityId === 9 || globalActivityId === 13 ? '<img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px;height: 16px;margin-right: 4px;" alt="积分" />' : '¥' }}{{userInfo.balance.toFixed(2)}}</div>
                </div>
              </div>
            </div>
            <div style="margin-top: 15px;">
              <div style="color:#B1B3B0;display:flex;justify-content:center;align-items: center;">
                <div style="margin-right: 3px;font-size: 12px;line-height: 0px;">有效期至</div>
                <img src="http://img.zhujiaxian.com/2023/10/5f343303b0bc45afaee493dce7a09ac8.png" style="width: 12px;height: 12px;" alt="">
              </div>
              <div style="margin-top: 6px;color:#C8C8C7;font-size: 11px;line-height: 12px;">{{userInfo.balanceExpirationTime}}</div>
            </div>
          </div>
          <div>
            <img src="http://img.zhujiaxian.com/2023/10/f801800f69f6477abf28db81ae522df9.png" style="width:2px;height:49px;margin-top: 6px;" alt="">
          </div>
          <div style="display:flex;flex-direction:column;span-align: center;">
            <div>
              <div style="display:flex;align-items:center;">
                <img src="http://img.zhujiaxian.com/2023/10/f733f86d440d4adc8b6310edb5b48153.png" alt="" style="width: 16px;height:16px;">
                <span style="font-size: 14px;color:#548732;">企业账户</span>
                <img src="http://img.zhujiaxian.com/2023/10/722e8f02a87f41eca9434c807ae91548.png" style="width: 14px;height:14px;" alt="">
              </div>
              <div>
                <div style="font-size:20px;font-weight:700;color: #315816;font-family: DIN;line-height: 23px;margin-top: 10px;">
                  <div style="padding-top: 10px;font-size: 22px;margin-top: 10px;line-height: 23px;display: flex;align-items: center;">{{ globalActivityId === 9 || globalActivityId === 13 ? '<img src="https://img.zhujiaxian.com/2025/09/c5cc377d7c4c44f489ddc1130c867d08.png" style="width: 16px;height: 16px;margin-right: 4px;" alt="积分" />' : '¥' }}{{userInfo.corporateAccounts.toFixed(2)}}</div>
                </div>
              </div>
            </div>
            <div style="margin-top: 15px;">
              <div style="color:#B1B3B0;display:flex;justify-content:center;align-items: center;">
                <div style="margin-right: 3px;font-size: 12px;line-height: 0px;">有效期至</div>
                <img src="http://img.zhujiaxian.com/2023/10/5f343303b0bc45afaee493dce7a09ac8.png" style="width: 12px;height: 12px;" alt="">
              </div>
              <div style="margin-top: 6px;color:#C8C8C7;font-size: 11px;line-height: 12px;">{{userInfo.corporateAccountsExpirationTime}}</div>
            </div>
          </div>
        </div>  
      </div>
    </div>
    <div class="user__order">
      <p class="user__title">我的订单</p>
      <div class='procedure' style="padding-top: 5px;">
        <div class='items' @click="getorderList(1)">
          <img src='http://img.zhujiaxian.com/2023/03/3e9f04a236fb466d885d8b363eab5334.png' alt="" srcset="">
          <span>待支付</span>
          <span class='num-badge' v-if="orderAmount.unPay>0">{{orderAmount.unPay}}</span>
        </div>
        <div class='items'  @click="getorderList(2)">
          <img src='http://img.zhujiaxian.com/2023/03/cfed4752ad27499f90b688ce905d2ec2.png' alt="" srcset="">
          <span>待发货</span>
          <span class='num-badge' v-if="orderAmount.payed>0">{{orderAmount.payed}}</span>
        </div>
        <div class='items'  @click="getorderList(3)">
          <img src='http://img.zhujiaxian.com/2023/03/458a6e61452144c3877d1074163ba007.png' alt="" srcset="">
          <span>待收货</span>
          <span class='num-badge' v-if="orderAmount.consignment>0">{{orderAmount.consignment}}</span>
        </div>
        <div class='items'  @click="getorderList(4)">
          <img src='http://img.zhujiaxian.com/2023/03/ce23ce48316f4c31ab277e1e8e39cae6.png' alt="" srcset="">
          <span>已完成</span>
        </div>
        <div class='items' @click="toRefund">
          <img src='http://img.zhujiaxian.com/2023/03/4b088fc5658a4546900b86bb1b8c4301.png' alt="" srcset="">
          <span>退款/售后</span>
        </div>
      </div>
      <div class="my-menu">
        <div class="memu-item" @click="deliveryAdd">
          <div class="i-name">
            <img src="http://img.zhujiaxian.com/2023/03/d0449db37c2c4c7bb5a59b2ff542f356.png" alt="">
            <span>收货地址</span>
          </div>
          <div class="arrowhead"></div>
        </div>
      </div>
      <div class="log-out" @click="loginout">
        <div class="log-out-n">
          <span>退出登录</span>
        </div>
      </div>
    </div>



    <div> -->

<div class='container'>
 <!-- 用户信息 -->
 <div style="background-image: url('https://img.zhujiaxian.com/2024/08/d3c3c4c4b3ad47aea5d44f3b6599bea7.png');background-size: 100%;">
  <div style="height: 6vh;">
  </div>
  <div class='userinfo-none' v-if="isAuthInfo" bindtap="getUserProfile">
   <div class="default-pic">
    <img  src="https://img.zhujiaxian.com/2024/09/ca52bae1504249148491cf7919b07baf.png" />
   </div>
   <div class="none-login">
    <div class="unlogin" style="margin-bottom: 10px;">
     <span v-if="userInfo.nickName == null" style="font-size:17px;font-weight: bolder;">{{userInfo.nickName}}</span>
     <span v-if="userInfo.nickName != null" style="font-size:17px;font-weight: bolder;">{{userInfo.nickName}}</span>
    </div>
    <div class="click-login"><span style="font-size: 15px;">{{userInfo.mobile}}</span></div>
   </div>
  </div>


  <div class='userinfo-none' v-if="!isAuthInfo">
   <div class="default-pic">
    <img src="https://img.zhujiaxian.com/2024/09/ca52bae1504249148491cf7919b07baf.png" />
   </div>
   <div class="none-login">
    <button class="unlogin" bindtap="toLogin">账户未登录</button>
    <button class="click-login" bindtap="toLogin" style="color: red;font-weight: bold;">点击去登录</button>
   </div>
  </div>
  <div class="info">
   <div class='income'>
    <div class='income-left' style="height:88px;margin-top:10px;padding-top:0px;margin-bottom: 10px;width: 40%;">
     <div bindtap="toDetailspay" class="break" style="width:138px;margin-left:10px;background:white;border-radius:6%;padding-top:5px;padding-bottom:5px;border-radius: 6%;">
      <div class='item'>{{ globalActivityId === 9 || globalActivityId === 13 ? '积分' : '余额' }}</div>
      <div class='num' v-if="isAuthInfo">{{userInfo.corporateAccounts.toFixed(2)}}</div>
      <div class='num' v-if="!isAuthInfo">0</div>
        <!-- <div style="font-size: 12px;" v-html="isBalanceExpired ? '<span style=\'color: #ff0000;\'>已冻结</span>' : '<span style=\'color: #999;\'>有效期：' + userInfo.corporateAccountsExpirationTime + '</span>'"></div> -->
         <div style="font-size: 12px;">{{ userInfo.corporateAccountsExpirationTime }}</div>
     </div>
    </div>
    <div class='income-right' style="height: 65px;margin-top: 10px;padding-top: 0px;margin-bottom: 10px;">
     <div bindtap='toMyCouponPage' style="margin-left: 22px;background: white;padding-top: 5px;padding-bottom: 5px;border-radius: 6%;">
      <div class='item'>优惠券</div>
      <div class='num'>0</div>
     </div>
    </div>
   </div>
  </div>
 </div>
 <div class='list-cont'>
  <div class='total-order' style="background: #fff;margin-top: 20px;margin: 10px 10px;border-radius: 10px;">
   <!-- 订单状态 -->
   <div class='order-tit'>
    <span style='font-weight:bold'>我的订单</span>
    <!-- <div class='checkmore' >
     <span>查看全部 </span>
     <span class='arrowhead'></span>
    </div> -->
   </div>
   <div class='procedure'>
    <div class='items'  @click="getorderList(1)">
     <img src='../../assets/images/icon/toPay.png' />
     <span>待支付</span>
     <span class='num-badge' v-if="orderAmount.unPay>0">{{orderAmount.unPay}}</span>
    </div>
    <div class='items'  @click="getorderList(2)">
     <img src='../../assets/images/icon/toDelivery.png' />
     <span>待发货</span>
     <span class='num-badge' v-if="orderAmount.payed>0">{{orderAmount.payed}}</span>
    </div>
    <div class='items'  @click="getorderList(3)">
     <img src='../../assets/images/icon/toTake.png' />
     <span>待收货</span>
     <span class='num-badge' v-if="orderAmount.consignment>0">{{orderAmount.consignment}}</span>
    </div>
    <div class='items'  @click="getorderList(4)">
     <img src='../../assets/images/icon/toComment.png' />
     <span>已完成</span>
    </div>
    <div class='items'  @click="toRefund">
     <img src='../../assets/images/icon/refund.png' />
     <span>退款/售后</span>
    </div>
   </div>
  </div>
  <!--end 订单状态 -->
  <div class='total-order' style="margin-top:20px;margin:10px 10px;border-radius: 10px;background: #fff;">
   <!-- 订单状态 -->
   <div class='order-tit' style="margin-left:15px;margin-right:15px;padding-left:0px;padding-right: 0px;">
    <span style='font-weight:bold'>服务专区</span>
   </div>
   <div class='procedures'>
    <div class='itemss' @click="togiftcard">
     <img src='../../assets/images/icon/gift.png' />
     <span>提货券激活</span>
    </div>
    <div class='itemss' @click="deliveryAdd">
     <img src='../../assets/images/icon/myAddr.png' />
     <span>收货地址</span>
    </div>
    <div class="itemss"  @click="tokefu">
     <img src='../../assets/images/icon/menu-01.png' />
     <span>联系客服</span>
     <button class="contact-btn"  style="width: 1000rpx;">联系客服</button>
    </div>
    <div class='itemss' >
     <!-- <img src='../../assets/images/icon/myCol.png' />
     <span>我的收藏</span> -->
    </div>
    <div class='itemss'>
     <!-- <img src='../../assets/images/icon/pwd.png' />
     <span>修改密码</span> -->
    </div>
   
   </div>
  </div>
  <div class="log-out" @click="loginout">
    <div class="log-out-n">
      <span>退出登录</span>
    </div>
  </div>
 </div>

</div>
    </div>
  </div>
</template>

<script>
// 引入登录接口
import { GetUserInfo,GetcenterInfo } from "@/https/http";
import headImg from "@/assets/images/touxiang.png";  //默认头像
export default {
  name: "user",
  data() {
    return {
      isAuthInfo:true,
      loginMode: true,  // 1. 登录模式
      username: "",
      pwd: "",
      userInfo:{},
      orderAmount: {},
      avatarSrc: headImg,  //头像
      ifLogined: false, // 登录状态
      ifShowModal: false, // 是否显示模态框
      gridArr: [
        // grid数组
        { id: 0, icon: "label-o", type: "我的订单" },
        { id: 1, icon: "bill-o", type: "优惠券" },
        { id: 2, icon: "goods-collect-o", type: "礼品卡" },
        { id: 3, icon: "location-o", type: "我的收藏" },
        { id: 4, icon: "flag-o", type: "我的足迹" },
        { id: 5, icon: "contact", type: "会员福利" },
        { id: 6, icon: "aim", type: "地址管理" },
        { id: 7, icon: "warn-o", type: "账号安全" },
        { id: 8, icon: "service-o", type: "联系客服" },
        { id: 9, icon: "question-o", type: "帮助中心" },
        { id: 10, icon: "smile-comment-o", type: "意见反馈" },
      ],
    };
  },
  created() {
    // 登陆前先看本人是否登陆过
    let user = JSON.parse(localStorage.getItem("userInfo"));
    // 用户名存在
    if (user) {
      this.username = user.username;  //用户名
      this.avatarSrc = user.avatar; //头像
      this.ifLogined = true; // 显示用户名
    }
    this.centerInfo()
    this.getloginData()
    this.$eventBus.$emit( 'changeCount')
  },
  computed: {
    // 从全局状态获取活动ID
    globalActivityId() {
      return this.$store.getters.getActivityId;
    },
    
    // 判断余额是否已冻结（有效期是否小于当前时间）
   // isBalanceExpired() {
    //  if (!this.userInfo || !this.userInfo.generalBalanceExpirationTime) {
   //     return false;
  //    }
  //    const now = new Date().getTime();
  //    const expirationTime = new Date(this.userInfo.generalBalanceExpirationTime).getTime();
  //    return expirationTime < now;
  //  }
  },
  methods: {
    //获取订单数字
    centerInfo(){
      GetcenterInfo().then(res=>{
        console.log(res);
        this.orderAmount = res.data.orderCountData
      })
    },
    tokefu(){
      this.$router.push({path: '/Customerservice'})
    },
    //跳转卡券激活页面
    togiftcard(){
      this.$router.push({path: '/giftcard'})
    },
    //跳转订单详情页
    getorderList(id){
      this.$router.push({path: '/orderList',query: { id: id }})
    },
    toRefund(){
      this.$router.push({path: '/afterSales'})
    },
    // 点击立即登录
    ljdl() {
      // this.ifShowModal = true;   
      this.$router.push({path: '/passwordlogin'})
    },
    deliveryAdd(){
      this.$router.push({path: '/delivery-address'})
    },
    // 提交用户名，密码信息
    // onSubmit() {
    //   this.getloginData(); //发送数据请求
    // },

    // 发送数据请求：登录注册
    getloginData() {
      GetUserInfo().then((res) => {
        console.log(res);
        this.isAuthInfo = true;
        this.userInfo = res.data
        // if (res.errno === 0) {
        //   console.log("登录成功");
        //   this.$toast.success("登录成功");
        //   localStorage.setItem("token", res.data.token);
        //   localStorage.setItem("userInfo", JSON.stringify(res.data.userInfo));
        //   this.ifShowModal = false; //不显示模态框
        //   this.ifLogined = true; // 显示用户名
        //   this.avatarSrc = res.data.userInfo.avatar; //头像
        //   this.username = res.data.userInfo.username;
        // }
      });
    },
    // 退出登录
    loginout() {
      //this.ifLogined = false; // 不显示用户名
           // this.avatarSrc = headImg; //头像
            // 清除token
            localStorage.removeItem("token");
            localStorage.removeItem("userInfo");
            // 刷新当前页
            this.$router.go(0);
            // 刷新当前页
            this.$router.go(0);
      // 登录了
     // if (this.ifLogined) {
          
        // this.$dialog
        //   .confirm({
        //     title: "退出登录",
        //     message: "是否退出登录",
        //   })
        //   .then(() => {
        //     // on confirm
        //     this.ifLogined = false; // 不显示用户名
        //     this.avatarSrc = headImg; //头像
        //     // 清除token
        //     localStorage.removeItem("token");
        //     localStorage.removeItem("userInfo");
        //     // 刷新当前页
        //     this.$router.go(0);
        //     // 刷新当前页
        //     this.$router.go(0);
        //   })
        //   .catch(() => {
        //     // on cancel
        //   });
     // }
    },
  },
};
</script>
<style lang="less" scoped>
.user {
  background-color: #f7f7f7;
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    gap: .2rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    padding-bottom: 1.18rem;
    .user__member {
        position: relative;
        .user__member-box_normal {
            // background-color: #8cc800;
            background-image: url('http://img.zhujiaxian.com/2023/10/7a6946a564c14330b900c033569c5fce.png');
            background-size: contain;
        }

        .user__member-box {
            position: relative;
            width: 100%;
            height: 4rem;
            .user__member-info {
                position: relative;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-orient: horizontal;
                -webkit-box-direction: normal;
                -ms-flex-direction: row;
                flex-direction: row;
                z-index: 1;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
                padding-top: .7rem;
                padding-left: .4rem;
                .user__member-info_head--bg {
                    width: 1.5rem;
                    height: 1.5rem;
                    border-radius: 1rem;
                    background-color: #fff;
                    padding: .02rem;
                    -webkit-box-sizing: border-box;
                    box-sizing: border-box;
                    .user__member-info_head--img{
                        width: 1.46rem;
                        height: 1.46rem;
                        border-radius: .48rem;
                    }
                }
                .user__member-info_right {
                    margin-left: .3rem;
                    display: -webkit-box;
                    display: -ms-flexbox;
                    display: flex;
                    -webkit-box-orient: vertical;
                    -webkit-box-direction: normal;
                    -ms-flex-direction: column;
                    flex-direction: column;
                    -webkit-box-pack: center;
                    -ms-flex-pack: center;
                    justify-content: center;
                    .user__member-info_top {
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        .user__member-info_name {
                            line-height: .8rem;
                            font-size: .46rem;
                            font-weight: 500;
                            color: #fff;
                            white-space: normal;
                            word-wrap: break-word;
                            word-spacing: normal;
                            word-break: break-all;
                            overflow: hidden;
                            span-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                        }
                    }
                    .user__member-info_bottom {
                        display: -webkit-box;
                        display: -ms-flexbox;
                        display: flex;
                        -webkit-box-align: center;
                        -ms-flex-align: center;
                        align-items: center;
                        .user__member-info_bottom_rank_name {
                              height: .52rem;
                              line-height: .32rem;
                              font-size: .4rem;
                              color: #fff;
                              background: url('https://image.benlailife.com/static/images/mycenter/member_icon02bg_4e19bb9a.png') 50% no-repeat;
                              background-size: 100% 100%;
                              -webkit-box-sizing: border-box;
                              box-sizing: border-box;
                              -ms-flex-negative: 0;
                              flex-shrink: 0;
                              display: -webkit-box;
                              display: -ms-flexbox;
                              display: flex;
                              -webkit-box-align: center;
                              -ms-flex-align: center;
                              align-items: center;
                              padding-right: .12rem;
                              margin-left: .18rem;
                              .user__member-info_bottom_rank_name:before {
                                    content: "";
                                    width: .36rem;
                                    height: .36rem;
                                    margin-left: -.2rem;
                                    background: url('https://image.benlailife.com/static/images/mycenter/member_icon02_4319e53f.png') 50% no-repeat;
                                    background-size: 100% 100%;
                                }
                          }
                    }
                }
            }
        }
        .user__member-level_normal {
            grid-template-columns: repeat(2,1fr);
        }
        .user__member-level {
            position: relative;
            width: 100%;
            box-sizing: border-box;
            padding: 0 .2rem;
            margin-top: -1.54rem;
            z-index: 1;
            .user__member-card{
              border-radius: .08rem;
              background: #fff;
              display: flex;
              -webkit-box-orient: vertical;
              padding: .2rem .2rem;
              border-radius: 12px;
              box-sizing: border-box;
              justify-content: space-evenly;
              // margin: 0px 15px;
              padding: 15px 0px;
          }
        }
    }
    .user__order{
        position: relative;
        border-radius: .08rem;
        background: #fff;
        margin-left: .2rem;
        margin-right: .2rem;
        .user__title {
            color: #000;
            font-size: .32rem;
            font-weight: 600;
            padding: .2rem 0 .2rem .2rem;
        }
        .user__order-grid {
          display: grid;
          grid-template-columns: repeat(5,1fr);
          grid-template-rows: repeat(1,1fr);
          .user__order-item {
              position: relative;
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              -webkit-box-orient: vertical;
              -webkit-box-direction: normal;
              -ms-flex-direction: column;
              flex-direction: column;
              -webkit-box-align: center;
              -ms-flex-align: center;
              align-items: center;
              height: 1.38rem;
              .van-badge__wrapper{
                height: 38px !important;
              }
              .user__order-icon {
                width: .76rem;
                height: .76rem;
            }
            .user__order-title {
                font-size: .24rem;
                color: #666;
            }
          }
          a {
              outline: none;
              -webkit-appearance: none;
              span-decoration: none;
              color: inherit;
          }
        }
        .procedure {
            display: flex;
            justify-content: space-around;
            align-items: center;
            font-size: 13px;
            height: 80px;
            .items {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                img {
                    width: 35px;
                    height: 35px;
                    margin-bottom: 10px;
                }
                .num-badge {
                    font-size: 12px;
                    position: absolute;
                    top: -7px;
                    right: -6px;
                    color: #fff;
                    border: 1.5px solid #e43130;
                    border-radius: 25px;
                    background: #e43130;
                    min-width: 15px;
                    height: 15px;
                    line-height: 15px;
                    span-align: center;
                    padding: 1px;
                    display: block;
                }
            }
        }
        .my-menu{
          background-color: #fff;
          position: relative;
          .memu-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 60px;
              .i-name {
                display: flex;
                align-items: center;
                position: absolute;
                left: 10px;
                img{
                    width: 25px;
                    height: 25px;
                    margin-right: 10px;
                }
                span{
                    font-size: 14px;
                }
            }
            .arrowhead {
                width: 7px;
                height: 7px;
                border-top: 1px solid #999;
                border-right: 1px solid #999;
                transform: rotate(45deg);
                margin-left: 5px;
                position: absolute;
                right: 20px;
            }
          }
        }
        .log-out {
            padding: 10px;
            span-align: center;
            margin-top: 10px;
            .log-out-n {
              font-size: 15px;
              margin: auto;
              width: 100px;
              padding: 10px;
              border-radius: 5px;
              color: #D03636;
              border: 1px solid #D03636;
          }
        }
    }
}






// 新页面
/* pages/user/user.wxss */

/* page {
  background-color: #f7f7f7;
  padding-bottom: 60rpx;
  width: 100%;
} */
.container {
  overflow-x: hidden;
  width: 100%;
}

.contact-btn {
  display: inline-block;
  position: absolute;
  width: 100%;
  background: salmon;
    opacity: 0;
}
/* 用户信息 */

.userinfo {
  position: relative;
  width: 100%;
  background: #fff;
  text-align: center;
  padding: 15px 0;
}

.userinfo .userinfo-avatar {
  overflow: hidden;
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
  margin: auto;
}

.userinfo .userinfo-avatar image{
   width: 80px;
  height: 80px;
}

.userinfo .userinfo-name {
  font-size: 15px;
  font-weight: bold;
  margin-top: 10px;
}

.binding-phone {
  position: relative;
  background: #fff;
  height: 40px;
  line-height: 40px;
  padding: 0 15px;
  border-top: 1px solid #f7f7f7;
  border-bottom: 1px solid #f7f7f7;
}

.binding-phone .show-tip {
  font-size: 13px;
}

.binding-phone .gotobinding {
  border-radius: 4px;
  font-size: 14px;
  color: #e24b4b;
  font-weight: bold;
}

/*end 用户信息 */

/** 未登录信息 */
.userinfo-none {
  display: flex;
  padding: 15px;

  align-items: center;
}
.userinfo-none .default-pic{
  padding-right:15px;
}
.userinfo-none .default-pic img{
  width:80px;
  height:80px;
  border-radius: 50px;
}
.none-login button{
  background: #fff;
}
.none-login button::after{
  border:0;
}
.none-login .unlogin{
  font-size:15px;
}
.none-login .click-login{
  font-size:13px;
}

/* 订单状态 */

.list-cont {
  
  width: 100%;
  background: #f7f7f7;
  margin-top: 10px;
}

.list-cont .total-order {
  
}

.list-cont .total-order .order-tit {
  display: flex;
  justify-content: space-between;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  border-bottom:1px solid #f7f7f7;
  padding: 0 15px;
}

.list-cont .total-order .order-tit .checkmore {
  font-size: 11px;
  color: #80848f;
  display: flex;
  align-items: center;
}

.list-cont .total-order .procedure {
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-size: 12px;
  height: 80px;
}

.list-cont .total-order .procedure .items {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}
/* .list-cont .total-order .procedure .items.refund-icon > image {
  width: 55rpx;
  height: 55rpx;
} */

.list-cont .total-order .procedure .items image {
  width:35px;
  height: 35px;
  margin-bottom: 10px;
}

.list-cont .total-order .procedure .items .num-badge {
  position: absolute;
  top: -7px;
  right: -6px;
  color: #e43130;
  border:1.5px solid #e43130;
  border-radius: 25px;
  background: #fff;
  min-width: 15px;
  height: 15px;
  line-height: 15px;
  text-align: center;
  padding: 1px;
  display: block;
}
.list-cont .total-order .procedures {
 display: flex;
 align-items: center;
 font-size: 12px;
 flex-wrap: wrap;
 height: 180px;
 /* height: 160rpx; */
}

.list-cont .total-order .procedures .itemss {
 position: relative;
 display: flex;
 flex-direction: column;
 align-items: center;
 flex-basis: 25%;
 box-sizing: border-box;
}
/* .list-cont .total-order .procedure .items.refund-icon > image {
 width: 55rpx;
 height: 55rpx;
} */
.list-cont .total-order .procedure .items img{
  width: 35px;
 height: 35px;
 margin-bottom:10px;
}
.list-cont .total-order .procedures .itemss img {
 width: 35px;
 height: 35px;
 margin-bottom:10px;
}

.list-cont .total-order .procedures .itemss .num-badge {
 position: absolute;
 top: -7px;
 right: -6px;
 color: #e43130;
 border:1.5px solid #e43130;
 border-radius: 25px;
 background: #fff;
 min-width: 15px;
 height: 15px;
 line-height: 15px;
 text-align: center;
 padding: 1px;
 display: block;
}

/* end 订单状态 */

/* 列表项 */

.list-cont .my-menu {
  /* width: 100%; */
  background-color: #fff;
  margin-top:10px;
  position: relative;
}

.list-cont .my-menu .memu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  border-bottom: 1px solid #f7f7f7;


}

.list-cont .my-menu .memu-item:nth-child(1) {
  border-top: 1px solid #f7f7f7;
}

.list-cont .my-menu .memu-item:last-child {
  border-bottom: none;
}

.list-cont .my-menu .memu-item text {
  font-size: 14px;
}
.list-cont .my-menu .memu-item image{
  width:25px;
  height:25px;
  margin-right:10px;

}
.list-cont .my-menu .memu-item .i-name{
  display: flex;
  align-items: center;
  position: absolute;
  left: 10px;
}

/* end 列表项 */

/* 箭头 */

.arrowhead {
  width: 7px;
  height: 7px;
  border-top: 1px solid #999;
  border-right: 1px solid #999;
  transform: rotate(45deg);
  margin-left: 5px;
  position: absolute;
  right: 17px;
}


/* 商品收藏消息等 */
.prod-col{
  margin-top:10px;
  background: #fff;
  display: flex;
  justify-content: space-around;
  padding:15px 0 5px 0;
  font-size: 12px;
}
.prod-col .col-item{
  text-align: center;
}
.prod-col .col-item .num{
  font-size: 16px;
    font-weight: 700;
    color: #3a86b9;
}

.prod-col .col-item .tit{
  line-height: 34px;
}


/* 退出登录 */
.log-out{
padding:10px;
text-align: center;
margin-top:10px;
margin-bottom: 20px;
}
.log-out-n{
font-size:15px;
margin: auto;
width:100px;
padding:10px;
border-radius: 5px;
/* background: #e43130; */
color:#95D46C;
border: 1px solid #95D46C;
}
/* 横排 */
.income{
  display: flex;
  color: #000;
  margin-bottom: 20px;
  margin-left: 10px;
  background: #fff;
  margin-right: 10px;
  margin-top: 10px;
  box-shadow: 0px 4px 5px #ededed;
  border-radius: 8px;
}
.income .income-left{
  text-align: center;
}
.income .income-right{
  width: 50%;
  text-align: center;
}
.income .item{
  font-size: 14px;
  margin-bottom: 10px;
  color: #999;
}
.income .num{
  font-size: 20px;
}


</style>